"use strict";
exports.__esModule = true;
exports.irregulars = {
    "bad": ["worse", "worst"],
    "far": ["further", "furthest"],
    "good": ["better", "best"],
    "late": ["later", "latest"],
    "little": ["less", "least"],
    "many": ["more", "most"],
    "much": ["more", "most"],
    "some": ["more", "most"],
    "old": ["older", "oldest"],
    "crowded": ["more crowded", "most crowded"]
};
